module.exports = __webpack_public_path__ + "img/Icon-navigation-help.063b5d2f.svg";